import { post, get, getFile } from '../helpers/fetchServicesMethods';
import { toast } from 'react-toastify';
import { url } from '../reducers/url';
import PubSub from 'pubsub-js';
import axios from 'axios';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

async function getSequenceSummary(workflowId) {

    try {
        let apiurl = url.seqWorkflow;
        apiurl = apiurl.replace('**', workflowId)

        //showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }

}

async function getMergeStrategy(workflowId) {

    try {
        let apiurl = url.mergeStrategyInfo;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }

}

async function getFulltextQuery(workflowId) {

    try {
        let apiurl = url.fullTextQuery;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);

            });
    } catch (error) {
        //toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }

}

async function getSequenceShare(workflowId) {

    try {
        let apiurl = url.seqShareInfo;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
// async function getSequenceResultShare(workflowId) {

//     try {
//         let apiurl = url.seqShareList;
//         apiurl = apiurl.replace('**',workflowId)

//         showLoader();
//         return await get(apiurl)
//             .then((response) => {
//                 hideLoader();
//                 return response;
//             })
//             .catch((error) => {
//                 hideLoader();
//                 // toast.error('Failed to change password');
//                 console.log("error::", error);

//             });
//     } catch (error) {
//         toast.error(error.response_content.message);
//         console.error(error, "errors");
//         hideLoader();
//     }
// }
async function getSeqAlert(workflowId) {

    try {
        let apiurl = url.seqAlertInfo;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function getSeqTechnical(workflowId, history, shouldDownload = true) {

    try {
        let apiurl = url.seqTechnicalData;
        apiurl = apiurl.replace('**', workflowId)

        if (!shouldDownload) {
            const baseUrl = process.env.REACT_APP_API_URL;
            return await axios.get(baseUrl + apiurl, {
                withCredentials: true,
                responseType: 'text'
            })
                .then((response) => response.data)
                .catch((error) => {
                    console.log("error::", error);
                });
        }

        showLoader();
        return await getFile(apiurl, history, 'techLog')
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}

async function getQueryNoHits(workflowId, history) {

    try {
        let apiurl = url.queryNoHits;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await getFile(apiurl, history, 'querySeq')
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}

async function getAlertRedo(workflowId) {

    try {
        let apiurl = url.getAlertRedos;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function updateSeqNotes(workflowId, updateParam) {

    try {
        let apiurl = url.updateSeqData;
        apiurl = apiurl.replace('WID', workflowId) + updateParam;
        // apiurl = apiurl.replace('**',notes)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function downloadQuerySeq(workflowId, history, shouldDownload = true) {

    try {
        let apiurl = url.downloadQuerySeq;
        apiurl = apiurl.replace('**', workflowId)

        showLoader();
        
        const baseUrl = process.env.REACT_APP_API_URL;
        
        // Get the data directly with responseType 'text'
        return await axios.get(baseUrl + apiurl, { 
            withCredentials: true,
            responseType: 'text'
        })
            .then((response) => {        
                // If shouldDownload is true, trigger the download
                if (shouldDownload && response.data) {
                    try {
                        const blob = new Blob([response.data], { type: 'text/plain' });
                        const url = window.URL.createObjectURL(blob);
                        
                        // Create a temporary link element (not appended to DOM)
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = 'queries.fasta.txt';
                        link.style.display = 'none'; // Hidden element
                        
                        // Trigger download without appending to DOM
                        link.click();
                        
                        // Clean up the object URL to prevent memory leaks
                        window.URL.revokeObjectURL(url);
                    } catch (downloadError) {
                        console.error('Download failed:', downloadError);
                        toast.error('Failed to download file');
                    }
                }
                
                hideLoader();
                return response.data;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function updateAlertSettings(workflowId, alertSettingValue, alertViewValue) {

    try {
        let apiurl = url.updateAlertSetting;
        apiurl = apiurl.replace('WID', workflowId)
        apiurl = apiurl.replace('**', alertSettingValue)
        // Sent as an empty value to clear a choice, but omitted entirely when the caller
        // passes undefined: the dispatcher only touches the stored view when the
        // parameter is present, so an unconfirmed dropdown cannot overwrite it.
        if (alertViewValue !== undefined) {
            apiurl = apiurl + '&alert_view=' + encodeURIComponent(alertViewValue || '')
        }

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function removeAlertSettings(workflowId) {

    try {
        let apiurl = url.removeAlert;
        apiurl = apiurl.replace('WID', workflowId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function removeResultSharing(postdata) {

    try {

        let apiurl = url.seqRemoveSharee;
        apiurl = apiurl.replace('**', postdata.workflowId)
        apiurl = apiurl.replaceAll('UID', postdata.removeId)

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
// async function getUserList(workflowId) {

//     try {
//         let apiurl = url.userList;
//         apiurl = apiurl.replace('**',workflowId)

//         showLoader();
//         return await get(apiurl)
//             .then((response) => {
//                 hideLoader();
//                 return response;
//             })
//             .catch((error) => {
//                 hideLoader();
//                 // toast.error('Failed to change password');
//                 console.log("error::", error);

//             });
//     } catch (error) {
//         toast.error(error.response_content.message);
//         console.error(error, "errors");
//         hideLoader();
//     }
// }
async function getFolderResultData(datas, folderId) {
    try {
        let apiurl = 'do=gqfolder.get_folder_info&format=json&id=' + folderId + '&extra=true';
        const data = {
            id: folderId
        }
        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}

// async function addResultSharing(postdata) {

//     try {
//         let apiurl = url.seqAddSharee;
//         apiurl = apiurl.replace('**',postdata.workflowId)
//         apiurl = apiurl.replaceAll('UID',postdata.userId)

//         showLoader();
//         return await get(apiurl)
//             .then((response) => {
//                 hideLoader();
//                 return response;
//             })
//             .catch((error) => {
//                 hideLoader();
//                 // toast.error('Failed to change password');
//                 console.log("error::", error);

//             });
//     } catch (error) {
//         toast.error(error.response_content.message);
//         console.error(error, "errors");
//         hideLoader();
//     }
// }
async function renameFolder(folderId, name) {
    try {
        let apiurl = 'do=gqfolder.rename&id=' + folderId + '&format=json&text_label=' + name;
        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function getDbSummary(workflowId) {

    try {
        let apiurl = url.personalDB;
        apiurl = apiurl.replace('**', workflowId)

        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function updateDbDesc(workflowId, updateParam) {
    try {
        let apiurl = url.updateDbDesc;
        apiurl = apiurl.replace('**', workflowId) + updateParam;

        showLoader();
        return await get(apiurl)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}
async function getVmReport(history, workflowId, fileName, download) {
    try {
        //&id=:ID&file_name=:FILE
        let api = url.getVmReport + "&id=" + workflowId + "&file_name=" + fileName;
        if (download) {
            api = api + "&is_download=true";
        }

        //showLoader();
        return await get(api, history)
            .then((response) => {
                //hideLoader();
                return response;
            })
            .catch((error) => {
                //hideLoader();
                console.log("error::", error);

            });
    } catch (error) {
        console.error(error, "errors");
        //hideLoader();
    }
}

async function getCmQuery(workflowId) {

    try {
        const api = url.cmQuery.replace('**', workflowId);

        showLoader();
        return await get(api)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);

            });
    } catch (error) {
        //toast.error(error.response_content.message);
        console.error(error, "errors");
        hideLoader();
    }
}

const searchResSequence = {
    getSequenceSummary,
    getSequenceShare,
    getSeqAlert,
    getSeqTechnical,
    getQueryNoHits,
    getAlertRedo,
    updateSeqNotes,
    downloadQuerySeq,
    updateAlertSettings,
    removeAlertSettings,
    //addResultSharing,
    removeResultSharing,
    //getUserList,
    //getSequenceResultShare,
    getFolderResultData,
    getMergeStrategy,
    getFulltextQuery,
    renameFolder,
    getDbSummary,
    updateDbDesc,
    getVmReport,
    getCmQuery
};

export default searchResSequence;
